import type { ReactNode } from "react";

export default function SectionLabel({ children }: { children: ReactNode }) {
  return (
    <div className="flex items-center gap-3">
      <span
        className="inline-block rounded-full"
        style={{ width: 8, height: 8, background: "#93C5FD" }}
      />
      <h2
        className="whitespace-nowrap"
        style={{
          fontSize: 13,
          letterSpacing: 0.1,
          color: "#ECECEC",
          fontWeight: 400,
          margin: 0,
          fontFamily: "'Space Grotesk', system-ui, sans-serif",
        }}
      >
        {children}
      </h2>
    </div>
  );
}